var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { attrs: { id: "news-center" } },
    [
      _vm.initialized
        ? [
            _c("ci-registration-modal", {
              attrs: {
                "gating-banner-location": "news_center",
                "return-button-text":
                  "ui.components.users.onboarding.register.back_to_news_center",
                "soft-gating": true,
              },
            }),
            _c("portal", { attrs: { to: "content-header" } }, [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "ci-collapsible-header",
                      rawName: "v-ci-collapsible-header",
                    },
                  ],
                  key: "newscenter-header",
                  staticClass: "ci-content-header sticky",
                  attrs: { id: "newscenter-header" },
                },
                [
                  _c(
                    "div",
                    { staticClass: "ci-content-header__inner pb-0" },
                    [
                      _c("h1", {
                        staticClass: "h2 header-title",
                        domProps: {
                          textContent: _vm._s(
                            _vm.$t("ui.views.news_center.heading")
                          ),
                        },
                      }),
                      _c(
                        "b-tabs",
                        {
                          staticClass: "ci-tabs no-border",
                          attrs: {
                            "tracking-overwrites": {
                              source: { name: "PortfolioOverview" },
                            },
                            queryParam: "currentTab",
                            replaceUrl: false,
                            tracking: false,
                          },
                          model: {
                            value: _vm.filter,
                            callback: function ($$v) {
                              _vm.filter = $$v
                            },
                            expression: "filter",
                          },
                        },
                        [
                          _c("b-tab", {
                            attrs: {
                              id: _vm.tabs.options[0].id,
                              title: _vm.tabs.options[0].label,
                            },
                          }),
                          _c("b-tab", {
                            attrs: {
                              id: _vm.tabs.options[1].id,
                              title: _vm.tabs.options[1].label,
                            },
                          }),
                          _c("b-tab", {
                            attrs: {
                              id: _vm.tabs.options[2].id,
                              title: _vm.tabs.options[2].label,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ]),
            _c(
              "portal",
              { attrs: { to: "ads-container-top" } },
              [
                _c("ci-suggested-external-content", {
                  attrs: { type: "display", id: _vm.adIds.header },
                }),
              ],
              1
            ),
            _c(
              "portal",
              { attrs: { to: "ads-container-right" } },
              [
                _c("ci-suggested-external-content", {
                  attrs: { type: "skyscraper", id: _vm.adIds.skyscraper },
                }),
                _c("ci-suggested-external-content", {
                  attrs: { type: "sidebar", id: _vm.adIds.sidebar_2nd },
                }),
              ],
              1
            ),
            _c(
              "b-tabs",
              {
                staticClass: "ci-tabs no-border",
                attrs: { "nav-wrapper-class": "d-none" },
                model: {
                  value: _vm.filter,
                  callback: function ($$v) {
                    _vm.filter = $$v
                  },
                  expression: "filter",
                },
              },
              [
                _c(
                  "b-tab",
                  {
                    attrs: {
                      id: _vm.tabs.options[0].id,
                      title: _vm.tabs.options[0].label,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-end ci-content-padding-x ci-content-padding-b",
                      },
                      [
                        _vm.showNewsSourcesEdit
                          ? _c(
                              "a",
                              {
                                staticClass:
                                  "user-settings-newssources-button flex-center text-gray-600 font-weight-semi cursor-pointer mr-5",
                                on: { click: _vm.handleEditNewsSourcesClick },
                              },
                              [
                                _c("span", { staticClass: "mdi mdi-cog mr-2" }),
                                _c("span", {
                                  staticClass: "d-none d-sm-inline",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "ui.views.news_center.news_sources.sm"
                                      )
                                    ),
                                  },
                                }),
                                _c("span", {
                                  staticClass: "d-inline d-sm-none",
                                  domProps: {
                                    textContent: _vm._s(
                                      _vm.$t(
                                        "ui.views.news_center.news_sources.xs"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "a",
                          {
                            staticClass:
                              "user-settings-interesttags-button flex-center text-gray-600 font-weight-semi cursor-pointer",
                            on: { click: _vm.handleEditInterests },
                          },
                          [
                            _c("span", { staticClass: "mdi mdi-cog mr-2" }),
                            _c("span", {
                              staticClass: "d-none d-sm-inline",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.views.news_center.edit_interests.sm"
                                  )
                                ),
                              },
                            }),
                            _c("span", {
                              staticClass: "d-inline d-sm-none",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.views.news_center.edit_interests.xs"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      id: _vm.tabs.options[1].id,
                      title: _vm.tabs.options[1].label,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-end ci-content-padding-x ci-content-padding-b",
                      },
                      [
                        _c("ci-checkbox", {
                          staticClass: "mr-3 filter-by-tags text-gray-600",
                          attrs: {
                            name: "interest_based_toggle",
                            label: _vm.$t(
                              "ui.views.news_center.interest_based"
                            ),
                            toggle: true,
                          },
                          model: {
                            value: _vm.filterByTags,
                            callback: function ($$v) {
                              _vm.filterByTags = $$v
                            },
                            expression: "filterByTags",
                          },
                        }),
                        _c(
                          "a",
                          {
                            staticClass:
                              "settings-interesttags-button flex-center text-gray-600 font-weight-semi cursor-pointer",
                            on: { click: _vm.handleEditInterests },
                          },
                          [
                            _c("span", { staticClass: "mdi mdi-cog mr-2" }),
                            _c("span", {
                              staticClass: "d-none d-sm-inline",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.views.news_center.edit_interests.sm"
                                  )
                                ),
                              },
                            }),
                            _c("span", {
                              staticClass: "d-inline d-sm-none",
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.views.news_center.edit_interests.xs"
                                  )
                                ),
                              },
                            }),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                ),
                _c(
                  "b-tab",
                  {
                    attrs: {
                      id: _vm.tabs.options[2].id,
                      title: _vm.tabs.options[2].label,
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "d-flex justify-content-end ci-content-padding-x ci-content-padding-b",
                      },
                      [
                        _c(
                          "b-tabs",
                          {
                            staticClass: "ci-tabs newscenter-simple no-border",
                            attrs: {
                              id: "second_filter",
                              queryParam: "sort_by",
                              replaceUrl: false,
                              tracking: false,
                              navWrapperClass: ["tab-nav-wrapper"],
                            },
                            model: {
                              value: _vm.sort_by,
                              callback: function ($$v) {
                                _vm.sort_by = $$v
                              },
                              expression: "sort_by",
                            },
                          },
                          [
                            _vm._l(
                              _vm.filterByWithin.options,
                              function (subtab) {
                                return [
                                  _c("b-tab", {
                                    attrs: { id: subtab.id },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "title",
                                          fn: function () {
                                            return [
                                              _c("span", {
                                                staticClass: "hasSeparator",
                                                domProps: {
                                                  textContent: _vm._s(
                                                    subtab.label
                                                  ),
                                                },
                                              }),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ]
                              }
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            _vm.showInterestPrompt
              ? [
                  _c("div", { staticClass: "ci-card ci-section p-5" }, [
                    _c(
                      "div",
                      { staticClass: "row mx-0 justify-content-lg-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-6 d-flex flex-column align-items-start justify-content-center px-0",
                          },
                          [
                            _c("h5", {
                              domProps: {
                                textContent: _vm._s(
                                  _vm.$t(
                                    "ui.views.news_center.select_interest_tags_prompt.description"
                                  )
                                ),
                              },
                            }),
                            _c("ci-button", {
                              staticClass:
                                "ci-select-user-interests mt-3 mb-3 align-self-center align-self-md-start",
                              attrs: {
                                variant: "filled-primary",
                                label: _vm.$t(
                                  "ui.views.news_center.select_interest_tags_prompt.button"
                                ),
                              },
                              on: { click: _vm.handleEditInterests },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-md-6 d-flex justify-content-center px-0",
                          },
                          [
                            _c("img", {
                              staticClass: "mw-100 mt-3 mt-md-0",
                              attrs: { src: _vm.interestSelectionIntroduction },
                            }),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]
              : !_vm.isLoading
              ? [
                  _vm.hasArticles
                    ? [
                        _c(
                          "div",
                          {
                            staticClass:
                              "main-content ci-content-padding-as-body-x",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "row no-gutters-handheld with-gutter-bottom",
                              },
                              _vm._l(_vm.articles, function (article) {
                                return _c(
                                  "div",
                                  {
                                    key: article.slug,
                                    staticClass:
                                      "d-flex col-12 col-md-6 col-xl-4",
                                  },
                                  [
                                    _c("ci-content-tile", {
                                      staticClass: "w-100",
                                      attrs: { "tile-data": article },
                                    }),
                                  ],
                                  1
                                )
                              }),
                              0
                            ),
                            _vm.meta.next_page
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "flex-center ci-content-padding-t ci-content-padding-as-body-b",
                                  },
                                  [
                                    _c("ci-button", {
                                      attrs: {
                                        label: _vm.$t(
                                          "ui.shared.global.load_more.contents"
                                        ),
                                        variant: "filled-primary",
                                        loading: _vm.loadingBtnState,
                                      },
                                      on: { click: _vm.fetchNextPage },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        ),
                      ]
                    : [
                        _c("div", { staticClass: "main-content flex-center" }, [
                          _c("div", {
                            staticClass: "p-4 text-center text-muted",
                            domProps: {
                              textContent: _vm._s(
                                _vm.$t("ui.shared.global.no_data_available")
                              ),
                            },
                          }),
                        ]),
                      ],
                ]
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }